// app/frontend/router/index.js
import { createRouter, createWebHistory } from 'vue-router'
import routes from './routes'
import { useAuthStore } from '@/stores/auth'

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach(async (to) => {
  const authStore = useAuthStore()

  if (!authStore.authChecked) {
    await authStore.checkAuthentication()
  }

  if (to.meta.requiresAuth && !authStore.isAuthenticated) {
    return { path: '/', query: { redirect: to.fullPath } }
  }

  if (to.meta.requiresAdmin && !authStore.user?.admin) {
    return { path: '/app/vocabulaire' }
  }

  if (to.name === 'Landing' && authStore.isAuthenticated) {
    return { path: '/app/vocabulaire' }
  }

  return true
})

export default router
